import React, { FC, ReactNode } from 'react';

interface OnboardingTextBlockProps {
  step: string
  stepName: string
  list: string[] | ReactNode[]
}

export const OnboardingTextBlock: FC<OnboardingTextBlockProps> = ({step, stepName, list}) => {
  return (
    <div className="onboarding-helper-block">
      <div className="onboarding-helper-block-line" />
      <div className="onboarding-helper-block-text">
        <div className="onboarding-helper-block-text-big step">{step}</div>
        <div className="onboarding-helper-block-text-big step-name">{stepName}</div>
        <ul className="onboarding-helper-block-text-list">
          {list.map((item) => (
            <li>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  )
};
